<template>
  <div v-if="drawComponent">
    <div class="row" v-if="showForm">
      <div class='col-sm-6'>
        <panel :title="formTitle" :footerShow="true">
          <div class="row">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.name') }">
                    <label class="control-label">Name</label>
                    <input type="text" v-model="object.name" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="name" v-validate=""  :title="errors.first('agencyForm.name')"/>
                    <div class="form-control-feedback" v-if="errors.has('agencyForm.name')">
                      <i class="icon-cancel-circle2"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.city') }">
                    <label class="control-label">City</label>
                    <input type="text" v-model="object.city" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="city" v-validate=""  :title="errors.first('agencyForm.city')"/>
                    <div class="form-control-feedback" v-if="errors.has('agencyForm.city')">
                      <i class="icon-cancel-circle2"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.address') }">
                    <label class="control-label">Address</label>
                    <input type="text" v-model="object.address" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="address" v-validate=""  :title="errors.first('agencyForm.address')"/>
                    <div class="form-control-feedback" v-if="errors.has('agencyForm.address')">
                      <i class="icon-cancel-circle2"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.zip') }">
                    <label class="control-label">ZIP code</label>
                    <input type="text" v-model="object.zip" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="zip" v-validate=""  :title="errors.first('agencyForm.zip')"/>
                    <div class="form-control-feedback" v-if="errors.has('agencyForm.zip')">
                      <i class="icon-cancel-circle2"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="control-label">Logo</label>
                <div class="thumbnail" v-if="object.logo">
                  <div class="thumb">
                    <a class="logo-image" :href="object.logo.fullscale" data-popup="lightbox">
                      <img v-if="object.logo.is_public" :src="object.logo.preview" alt="logo"/>
                      <img v-if="!object.logo.is_public" v-auth-img="object.logo.preview" alt="logo"/>
                    </a>
                    <div class="caption-overflow">
                        <span>
                          <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeLogo()">Remove</a>
                        </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <UploadForm :dropzone="true" accept="image/*" @uploadComplete="uploadComplete" @uploadError="uploadError"></UploadForm>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.country') }">
                <label class="control-label">Country</label>
                <input type="text" v-model="object.country" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="country" v-validate=""  :title="errors.first('agencyForm.country')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.country')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.region') }">
                <label class="control-label">Region</label>
                <input type="text" v-model="object.region" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="region" v-validate=""  :title="errors.first('agencyForm.region')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.region')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.director_name') }">
                <label class="control-label">Director name</label>
                <input type="text" v-model="object.director_name" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="director_name" v-validate=""  :title="errors.first('agencyForm.director_name')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.director_name')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.email') }">
                <label class="control-label">Email</label>
                <input type="text" v-model="object.email" placeholder="agency@email.com" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="email" v-validate=""  :title="errors.first('agencyForm.email')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.email')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.phone') }">
                <label class="control-label">Phone</label>
                <input type="text" v-model="object.phone" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="phone" v-validate=""  :title="errors.first('agencyForm.phone')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.phone')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.website_url') }">
                <label class="control-label">Website URL</label>
                <input type="text" v-model="object.website_url" placeholder="https://www.domain.com" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="website_url" v-validate=""  :title="errors.first('agencyForm.website_url')"/>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.website_url')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group has-label" :class="{'has-error': errors.has('agencyForm.notes') }">
                <label class="control-label">Notes</label>
                <textarea :rows="4" v-model="object.notes" :readonly="mode.readonly" class="form-control" data-vv-scope="agencyForm" data-vv-name="notes" v-validate=""  :title="errors.first('agencyForm.notes')"></textarea>
                <div class="form-control-feedback" v-if="errors.has('agencyForm.notes')">
                  <i class="icon-cancel-circle2"></i>
                </div>
              </div>
            </div>
          </div>
          <div slot="footerElements">
            <div class="pull-right">
              <router-link tag="button" :to="{name: 'agency'}" class="btn btn-link legitRipple">Cancel</router-link>
              <button type="submit" @click.prevent="saveData()" :disabled="errors.any('agencyForm')" class="btn btn-primary legitRipple">Save changes</button>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import AgencyService from '@/services/agency.service'

import Panel from '@/components/_partial/_atomic/panel'
import UploadForm from '@/components/_partial/UploadForm'

import validateMixin from '@/helpers/mixins/_validateMixin'

export default {
  name: 'AgencyForm',
  components: {
    Panel,
    UploadForm
  },
  mixins: [validateMixin],

  props: {
    'entity': {
      type: Object
    },
    'oid': {
      type: [Number, String],
      required: true
    },
    'parentId': {
      type: [Number, String]
    }
  },
  data () {
    return {
      id: null,
      object: {},
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: AgencyService,
      statuses: [],
      systemStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        resetAfterMount: false
      },
      /** **/
      editMode: false,
      objectState: {},
      /** **/
      groupEditMode: false,
      groupViewMode: false,
      groupAddMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true
    }
  },

  computed: {
    formTitle: function () {
      let title = 'New '
      let entity = 'agency'
      if (this._is('agencyAdmin') || this.object.parent_id || this.parentId) {
        entity = 'sub' + entity
      }
      return title + entity
    }
  },

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.statuses = []
    if (this.parentId) {
      this.object.parent_id = this.parentId
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'agency.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                this.object[i] = result[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          })
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'required_at') {
              this.object.period = this.$moment(this.object[i]).format(Vue.config.localizedFormat.date)
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.id = this.object.id
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
      if (this.parentId) {
        this.object.parent_id = this.parentId
      }
    },

    setItemStatus (item, status) {
      this.service.update(item, {
        'id': item,
        'status': status
      }, result => {
        this.service.item(result.id).then(newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    saveData () {
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), result => {
          if (this.editMode) {
            this.editMode = false
          }
          this.refresh()
        }, (error) => {
          if (Array.isArray(error.body)) {
            for (let e in error.body) {
              this.addError(error.body[e], 'agencyForm')
            }
          }
        })
      } else {
        this.service.create(this.prepareData(this.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.$router.push('/agency/details/' + parseInt(this.object.id))
        }, (error) => {
          if (Array.isArray(error.body)) {
            for (let e in error.body) {
              this.addError(error.body[e], 'agencyForm')
            }
          }
        })
      }
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true

      this.objectState = Object.assign({}, this.object)
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true

      this.object = this.objectState
      this.$forceUpdate()
    },

    saveChanges () {
      if (this.hasChanges) {
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareData (obj) {
      let result = Object.assign({}, obj)
      return result
    },

    canBeChanged () {
      let result = typeof this.object === 'object'
      result = result && this.object.status === 1
      return result
    },

    changePublicAgency (event) {
      this.object.is_public = event.value
    },

    /** invoice can be **/

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
    },

    /** action methods **/
    setLogo (image) {
      this.object = Object.assign(this.object, {
        logo: image || null
      })
      this.object.logo_image_id = image.id || null
      this.$forceUpdate()
    },

    removeLogo () {
      this.object.logo = null
      this.object.logo_image_id = null
      this.$forceUpdate()
    },

    uploadComplete (file) {
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    }

    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>
.logo-image img {
  max-height: 112px;
  min-height: 112px;
  max-width: 100%;
  width: auto;
}
</style>
